import React from 'react'

// The two glyphs the header draws, inline, as plain SVG.
//
// They used to be `import { WhatsApp, Menu } from '@material-ui/icons'`, which
// is a React component, an SvgIcon wrapper, a JSS sheet and MUI's theme
// machinery for two shapes that are one path each. DESIGN.md §3: the home
// chunk has a 250 KB budget and the header is in it. Nothing else in this
// component imports MUI now, so the mobile menu no longer pulls Menu,
// MenuItem, IconButton and Popover into the fold either.
//
// Both are decorative: the links around them carry the words, so each glyph is
// aria-hidden and the accessible name comes from real text (DESIGN.md §7).

// The WhatsApp mark, 24px grid, the same path @material-ui/icons shipped.
// Its colour is --whatsapp and it is set in header.css, because the glyph is
// the ONLY thing on this site that green is allowed to touch (DESIGN.md §3).
export const WhatsAppGlyph = () => (
  <svg className="gwmc-header-wa-glyph" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M16.75 13.96c.25.13.41.2.46.3.06.11.04.61-.21 1.18-.2.56-1.24 1.1-1.7 1.12-.46.02-.47.36-2.96-.73-2.49-1.09-3.99-3.75-4.11-3.92-.12-.17-.96-1.38-.92-2.61.05-1.22.69-1.8.95-2.04.24-.26.51-.29.68-.26h.47c.15 0 .36-.06.55.45l.69 1.87c.06.13.1.28.01.44l-.27.41-.39.42c-.12.12-.26.25-.12.5.12.26.62 1.09 1.32 1.78.91.88 1.71 1.17 1.95 1.3.24.14.39.12.54-.04l.81-.94c.19-.25.35-.19.58-.11l1.67.88M12 2a10 10 0 0 1 10 10 10 10 0 0 1-10 10c-1.97 0-3.8-.57-5.35-1.55L2 22l1.55-4.65A9.969 9.969 0 0 1 2 12 10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8c0 1.72.54 3.31 1.46 4.61L4.5 19.5l2.89-.96A7.95 7.95 0 0 0 12 20a8 8 0 0 0 8-8 8 8 0 0 0-8-8z" />
  </svg>
)

// Three bars, or a cross once the panel is open. Drawn as strokes so the one
// `stroke-width` in header.css governs both states and neither needs a fill.
export const MenuGlyph = ({ open = false }) => (
  <svg className="gwmc-header-menu-glyph" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    {open ? (
      <path d="M5 5 19 19 M19 5 5 19" />
    ) : (
      <path d="M3 7h18 M3 12h18 M3 17h18" />
    )}
  </svg>
)
